import {createContext} from "preact/compat";
import {useServices} from "@/services-context.tsx";
import {CUSTOMER_CHANNEL_LISTENER_NAME} from "@/services/customer-channel.ts";
import {useContext, useLayoutEffect} from "preact/hooks";

export enum Templates {
    DEFAULT = "default",
    BLACK_AND_BLUE = "black-and-blue",
}

export const TemplateProvider = ({ defaultTemplate, children }: {defaultTemplate: string, children: preact.ComponentChildren}) => {
    const services = useServices([CUSTOMER_CHANNEL_LISTENER_NAME]);
    const preloadedTemplate = services.customerChannel.template ?? defaultTemplate;
    const template = preloadedTemplate as Templates ?? Templates.DEFAULT;

    useLayoutEffect(() => {
        document.body.setAttribute('data-template',  template);

        return () => {
            document.body.removeAttribute('data-template');
        };
    }, [ template]);

    return <TemplateContext.Provider value={{template}}>{children}</TemplateContext.Provider>;
};

type LayoutContextType = {
    template: Templates;
};

const TemplateContext = createContext<LayoutContextType>(null!);

export const useTemplate = () => {
    return useContext(TemplateContext);
};
